/**
 * @file vue页面入口文件
 */
import Vue from 'vue';
import App from './container/App';
import store from './store';
import router from './router';
import {Loading, ErrorLoading} from '@baidu/map-mui';
import {Toast} from '@baidu/onemap-design';
import VueLazyload from 'vue-lazyload';
import {sendLog} from '@/pages/pano-feed/helper/log.js';

// Weirwood监控
import {initVueWeirwood, initHaotianjing} from '@baidu/map-fe-utils';
import WeirwoodJson from './weirwood.json';
if (process.env.NODE_ENV === 'production') {
    initVueWeirwood(Vue, WeirwoodJson);
}

import debounce from './constant/debounce';

import '@/common/style/reset.scss';
import '@/common/style/base.scss';

Loading.install(Vue);
ErrorLoading.install(Vue);
Toast.install(Vue);
// Badge.install(Vue);

Vue.use(debounce);
Vue.use(VueLazyload, {
    preLoad: 1.8,
    listenEvents: ['scroll', 'transitionend']
});

// 初始化昊天镜
initHaotianjing();

window.sendLog = sendLog;

Vue.config.productionTip = false;
new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app');
